import { handleDispatchResult } from '@wajeez-web/core/utils';
import { store } from '@wajeez-web/stores/base';
import { Server } from '@wajeez-web/core/api-base';

import { createBehaviourEventAsync } from './slices';

export const createBehaviourEvent = async (
  data: Server.CreateBehaviourEventInput,
  onSuccess?: (response: number) => void | Promise<void>
) => {
  const res = await store.dispatch(createBehaviourEventAsync(data));

  return handleDispatchResult(res, onSuccess);
};
